export const inputSpacing = 4;
